import React, { useEffect, useState } from 'react';
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Resize,
  Sort,
  ContextMenu,
  Filter,
  Page,
  ExcelExport,
  PdfExport,
  Edit,
  Inject,
} from '@syncfusion/ej2-react-grids';
import axios from 'axios';
import { format } from 'date-fns-jalali';

import { contextMenuItems, ordersGrid } from '../data/dummy';
import { Header } from '../components';
import { baseUrl } from '../data/baseURL';

const Modal = ({ isOpen, onClose, data, handleStatus }) => {

  const [isLoading, setIsLoading] = useState(false)
  
  async function toggleStatus() {
    const token = localStorage.getItem("token");
    setIsLoading(true)
    if (data.isVerified) {
      await axios.put(`${baseUrl}/Article/Comment/Verify`, {
        id: data.id,
        isVerified: false
      } , {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }).then(r=>{
        data.isVerified = false
        handleStatus(false);
      })
    } else {
      await axios.put(`${baseUrl}/Article/Comment/Verify`, {
        id: data.id,
        isVerified: true
      } , {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }).then(r=>{
        data.isVerified = true
        handleStatus(true)
      })
    }
    setIsLoading(false)
  }

  if (!isOpen) return null;

  return (
    <div style={modalBackdropStyles}>
      <div style={modalStyles}>
        <div style={modalHeaderStyles}>
          <h3 style={modalTitleStyles}>جزئیات روایت {data.id}</h3>
          <button onClick={onClose} style={modalCloseButtonStyles}>
            &times;
          </button>
        </div>
        <div style={modalContentStyles}>
          <form style={formStyles}>
            <div style={formGroupStyles}>
              <label style={labelStyles} htmlFor="first-name">
                نام:
              </label>
              <input
                style={inputStyles}
                type="text"
                id="first-name"
                name="first-name"
                value={data.name}
                disabled
              />
            </div>
            <div style={formGroupStyles}>
              <label style={labelStyles} htmlFor="mobile-number">
                شماره همراه:
              </label>
              <input
                style={inputStyles}
                type="text"
                id="mobile-number"
                name="mobile-number"
                value={data.phoneNumber}
                disabled
              />
            </div>
            <div style={formGroupStyles}>
              <label style={labelStyles} htmlFor="mobile-number">
                روایت:
              </label>
              <textarea
                style={inputStyles}
                type="text"
                id="mobile-number"
                name="mobile-number"
                disabled
              >{data.content}</textarea>
            </div>
            <div style={formGroupStyles}>
              <label style={labelStyles} htmlFor="birth-date">
                تاریخ انتشار:
              </label>
              <input
                style={inputStyles}
                type="text"
                id="birth-date"
                name="birth-date"
                value={data.createdAt}
                disabled
              />
            </div>
            <div style={formGroupStyles}>
              <label style={labelStyles} htmlFor="birth-date">
                وضعیت:
              </label>
              <input
                style={inputStyles}
                type="text"
                id="birth-date"
                name="birth-date"
                value={data.isVerified ? "منتشر شده" : "در انتظار تایید"}
                disabled
              />
            </div>
          </form>
        </div>
        <div style={modalFooterStyles}>
          <button onClick={toggleStatus} style={{...buttonStyles, backgroundColor: isLoading ? "gray" : "#E9AF00"}} disabled={isLoading}>{data.isVerified ? "تغییر وضعیت به منتشر نشده" : "تغییر وضعیت به منتشر شده"}</button>
          {isLoading && "در حال تغییر وضعیت..."}
        </div>
      </div>
    </div>
  );
};

// Modal Styles
const modalBackdropStyles = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 1000,
};

const modalStyles = {
  backgroundColor: "#fff",
  borderRadius: "8px",
  width: "80%",
  maxWidth: "700px",
  padding: "20px",
  position: "relative",
  boxShadow: "0 5px 15px rgba(0, 0, 0, 0.3)",
};

const modalHeaderStyles = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  borderBottom: "1px solid #e0e0e0",
  paddingBottom: "10px",
};

const modalFooterStyles = {
  display: "flex",
  gap: "20px",
  alignItems: "center",
  borderTop: "1px solid #e0e0e0",
  paddingTop: "20px",
  color: "gray"
};

const modalTitleStyles = {
  margin: 0,
  fontSize: "20px",
  fontWeight: "bold",
};

const modalCloseButtonStyles = {
  background: "none",
  border: "none",
  fontSize: "24px",
  cursor: "pointer",
  padding: "0 10px"
};

const modalContentStyles = {
  maxHeight: "70vh",
  overflowY: "auto",
  padding: "20px 0"
};

const formStyles = {
  display: "flex",
  flexDirection: "column",
  gap: "15px",
};

const sectionTitleStyles = {
  fontSize: "18px",
  fontWeight: "bold",
  borderBottom: "1px solid #e0e0e0",
  paddingBottom: "5px",
  marginBottom: "10px",
};

const formGroupStyles = {
  display: "flex",
  flexDirection: "column",
  gap: "5px",
};

const labelStyles = {
  fontSize: "14px",
  fontWeight: "bold",
};

const inputStyles = {
  padding: "10px",
  borderRadius: "4px",
  border: "1px solid #ccc",
  fontSize: "14px",
  width: "100%",
  WebkitAppearance: "none",
  MozAppearance: "none"
};

const textAreaStyles = {
  padding: "10px",
  borderRadius: "4px",
  border: "1px solid #ccc",
  fontSize: "14px",
  width: "100%",
  minHeight: "80px",
};

const dividerStyles = {
  margin: "20px 0",
  border: "none",
  borderBottom: "1px solid #e0e0e0",
};

const buttonStyles = {
  backgroundColor: "#E9AF00",
  color: "white",
  padding: "10px 20px",
  borderRadius: "5px"
}

function Comments() {
  const [ordersData, setOrdersData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const editing = { allowDeleting: true, allowEditing: true };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem('token');

        const response = await axios.get(`${baseUrl}/Article/Comment`, {
          // params: {
          //   formType: 3,
          // },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        let data = []
        if(response) {
          response.data.data.forEach(post => {
            data.push({
              ...post,
              landingImage: post.articleImg,
              createdAt: format(new Date(post.createdAt * 1000), "d MMMM yyyy")
            })
          })
        }
        setOrdersData(data);
      } catch (error) {
        console.error('Error fetching data from API', error);
      }
    };

    fetchData();
  }, []);

  const handleStatus = (status) => {
    if (selectedRowIndex) {
      let c = ordersData[selectedRowIndex];
      c.isVerified = status;
      setOrdersData([
        ...ordersData,
        c
      ]);
    }
  }
  
  const handleRowClick = async (row, index) => {
    setSelectedRowData(row);
    setSelectedRowIndex(index);
    setIsModalOpen(true);
  };

  return (
    <div className="m-2 md:m-10 mt-24 p-2 md:p-10 bg-white rounded-3xl">
      <Header category="Page" title="روایت ها" />
      <GridComponent
        id="gridcomp"
        dataSource={ordersData}
        allowPaging
        allowSorting
        allowExcelExport
        allowPdfExport
        contextMenuItems={contextMenuItems}
        rowSelected={(args) => handleRowClick(args.data, args.rowIndex)}
      >
        <ColumnsDirective>
          {ordersGrid.map((item, index) => (
            <ColumnDirective key={index} {...item} />
          ))}
        </ColumnsDirective>
        <Inject
          services={[
            Resize,
            Sort,
            ContextMenu,
            Filter,
            Page,
            ExcelExport,
            Edit,
            PdfExport,
          ]}
        />
      </GridComponent>
      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        data={selectedRowData}
        handleStatus={handleStatus}
      />
    </div>
  );
}

export default Comments;
